import { ConfigSchema } from '@mbrtargeting/metatag-config-types';
import { PublisherAPI } from '@mbrtargeting/metatag-shared-types/metatag-core';

//todo extend ConfigSchema in packages/config-types
export interface Config extends ConfigSchema {
    dependencies: {
        coreFile: string
        scripts: string[]
    };
}

export enum LoadState {
    LOADER = 'loader',
    CORE = 'core',
}

export interface SDG {
    loadState?: LoadState,
    cmd: Function[];
    Publisher: PublisherAPI,
}

export interface Dimensions {
    width: number,
    height: number,
}

export enum DimensionsSource {
    DEFAULT = 'default',
    CURRENT = 'current',
    CSS = 'css',
    FORMAT = 'format',
    PUBLISHER = 'publisher',
    CREATIVE = 'creative',
}
